import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function VarianceBadge({ diffPct }: { diffPct: number | null }) {
  if (diffPct == null) return <span className="text-[11px] text-gray-300">—</span>;

  // diffPct = timer-overforbruk: positivt = brukte MER enn budsjettert (dårlig),
  // negativt/0 = på eller under budsjett (bra). Feedback (Erik 26.06):
  // grønn ≤0 %, gul 0–8 %, rød ≥8 % overforbruk.
  let bgColor = "bg-green-100 text-green-700"; // ≤ 0 % (på/under budsjett)
  if (diffPct > 0 && diffPct < 8) bgColor = "bg-yellow-100 text-yellow-700"; // 0–8 % overforbruk
  if (diffPct >= 8) bgColor = "bg-red-100 text-red-700"; // ≥ 8 % overforbruk

  const label = diffPct > 0 ? `+${Math.round(diffPct)}%` : `${Math.round(diffPct)}%`;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={cn("inline-block px-2.5 py-1 rounded-md text-[11px] font-medium", bgColor)}>
          {label}
        </div>
      </TooltipTrigger>
      <TooltipContent side="top" className="text-xs">
        Budsjetteringsavvik
      </TooltipContent>
    </Tooltip>
  );
}
